import compose from 'recompose/compose';
import { withModel } from '../../../../view/data-providers/model';
import CheckoutHeader from './CheckoutHeader';

const enhance = compose(
  withModel,
);

export default enhance(CheckoutHeader);



// WEBPACK FOOTER //
// ./src/client/js/view/components/MainCheckout/CheckoutHeader/index.js